import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
/* eslint-disable max-len */
import { useController, useFormContext, } from 'react-hook-form';
import { useContext, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@genericBookings/store/hooks';
import { Actions } from '@widgets/GenericBookings/components/AttendeesSelector/styles';
import { ContinueButton } from '@bookingForm/styles/buttons';
import { useCallback, useEffect, useMemo } from 'preact/compat';
import AttendeesModal from '@widgets/DIYDayTickets/components/AttendeesModal';
import { OptionsCTX as DIYDayTicketOptionsContext } from '@widgets/DIYDayTickets/context/Options';
import { getActivities, getFetchingStatus, getSelectedActivities, getUnselectedActivities, readSessions, setActivities, } from '@genericBookings/store/reducers/activities';
import { useStepCompletion } from '@widgets/DayTickets/context/Steps';
import useDidMount from 'beautiful-react-hooks/useDidMount';
import { defaultVisitors } from '@genericBookings/types/Visitors';
import useQueryParams from '@widgets/DIYDayTickets/hooks/useQueryParams';
import { visitorCount, visitorsFromSchema } from '@genericBookings/visitorUtils';
import { useTimeConflict } from '@bookingForm/context/TimeConflicts';
import { Card, CardContainer, CardContent, CardPicture, CardSubtitle, CardTitle, CardCopy, Checkbox, List, NonSelectedWrapper, SelectedWrapper, Title, Wrapper, } from './styles';
function ActivityPicker(props) {
    // Set up react-hook-form
    const { name: fieldName, 
    // onNextSection,
    productId, } = props;
    const { control, getValues, setValue } = useFormContext();
    const [selectedActivity, setSelectedActivity] = useState(null);
    const { minActivities, maxActivities, isMulti, isBuilder, analyticsTitle, analyticsUrl, analyticsPath, } = useContext(DIYDayTicketOptionsContext);
    const allActivities = useAppSelector(getActivities);
    const selectedActivities = useAppSelector(getSelectedActivities);
    const unselectedActivities = useAppSelector(getUnselectedActivities);
    const values = getValues();
    const date = getValues('VisitDate');
    const { initTimePeriods } = useTimeConflict();
    const { requestingSessions } = useAppSelector(getFetchingStatus);
    const { sessions, } = useQueryParams(DIYDayTicketOptionsContext);
    const { modifyStep, activitiesStep } = useStepCompletion();
    const dispatch = useAppDispatch();
    const handleDidMount = useCallback(async () => {
        let initialised = activitiesStep.isInitialised;
        if (isBuilder) {
            let currActivities = allActivities;
            if (sessions && currActivities.length > 0 && !activitiesStep.isInitialised) {
                currActivities = allActivities.map((curr) => {
                    const session = sessions.find((sess) => sess.ActivityId === curr.activity.id);
                    return session ? {
                        ...curr,
                        visitors: visitorsFromSchema(session),
                        selected: session.SessionId !== null,
                    } : curr;
                });
                setValue('Sessions', sessions);
                await dispatch(setActivities(currActivities));
                initialised = true;
            }
            // set each activity session value that is not already initialised
            currActivities.forEach(({ activeSession, activity: { id: activityId }, visitors, }, idx) => {
                if (!getValues(`Sessions.${idx}`)) {
                    setValue(`Sessions.${idx}`, {
                        ActivityId: activityId,
                        SessionId: activeSession ? activeSession.SessionId : null,
                    });
                    const tmpVisitors = visitors && visitorCount(visitors) > 0 ? visitors : defaultVisitors;
                    Object.keys(tmpVisitors).forEach((key, visitorIdx) => {
                        setValue(`Sessions.${idx}.Visitors${visitorIdx}`, tmpVisitors[key]);
                    });
                }
            });
        }
        modifyStep(activitiesStep, activitiesStep.isComplete, true, initialised);
        // modifyStep(step.step, step.isComplete, true, false);
    }, [allActivities, getValues, isBuilder, modifyStep, sessions, setValue, activitiesStep, unselectedActivities]);
    useDidMount(handleDidMount);
    const { field: { value: fieldValue },
    // fieldState: { error, invalid, isTouched, },
     } = useController({
        name: fieldName,
        control,
    });
    const canProceed = useMemo(() => selectedActivities.length >= minActivities && selectedActivities.length <= maxActivities, [selectedActivities, minActivities, maxActivities]);
    const buttonText = useMemo(() => (!canProceed ? 'Pick more' : 'Book now'), [canProceed]);
    const handleToggle = (activity) => {
        setSelectedActivity(activity);
    };
    const getActivityIdx = useCallback((currActivity) => allActivities.findIndex((loopActivity) => currActivity.activity.id === loopActivity.activity.id), [allActivities]);
    const handleModalClose = () => {
        setSelectedActivity(null);
    };
    const handleModal = (activityInput) => {
        // onHandleChange(activityInput, getActivityIdx(activityInput));
        handleModalClose();
    };
    const nextSection = async () => {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'page_view', {
                page_title: `${analyticsTitle} - Activity Picker`,
                page_location: `${analyticsUrl}step-3`,
                page_path: `${analyticsPath}step-3`,
                send_to: 'UA-44012490-1',
            });
        }
        await dispatch(readSessions({
            activities: selectedActivities,
            productId,
            isMulti,
            values,
            date,
        }));
        initTimePeriods([]);
        modifyStep(activitiesStep, true, true, true);
    };
    useEffect(() => {
        window.dispatchEvent(new CustomEvent('primary.action.override', {
            detail: {
                buttonText,
                buttonAction: () => {
                    if (canProceed) {
                        nextSection()
                            .then(() => { });
                    }
                },
                buttonEnabled: canProceed,
            },
        }));
    }, [canProceed, buttonText, nextSection]);
    const printActivity = (activitySessionsWithVisitors, selected = false) => {
        const { activity } = activitySessionsWithVisitors;
        return (_jsxs("li", { children: [_jsx(Checkbox, { type: "checkbox", name: "SelectedActivities", value: activity.id, id: `selectable-activity-${activity.id}`, onChange: () => handleToggle(activitySessionsWithVisitors), checked: selected }), _jsx(CardContainer, { for: `selectable-activity-${activity.id}`, children: _jsxs(Card, { children: [activity.image && (_jsx(CardPicture, { children: _jsx("img", { src: activity.image.src, alt: activity.image.alt }) })), _jsxs(CardContent, { children: [_jsx(CardTitle, { children: activity.label }), _jsx(CardSubtitle, { children: activity.sublabel }), _jsx(CardCopy, { children: activity.description }), activity.ages && (_jsx("ul", { className: "tags", children: _jsx("li", { className: "tags__item", children: _jsx("div", { className: "tag tag--large tag--aero", children: _jsx("span", { className: "tag__text", children: activity.ages }) }) }) }))] })] }) })] }, `selectable-activity-${activity.id}`));
    };
    const renderSelectableActivities = () => {
        // const nonSelectedActivities = selectableActivities?.filter((activity) => !selectedActivities.some((selectedActivity) => selectedActivity.id === activity.id));
        // eslint-disable-next-line no-self-compare
        const nonSelectedTitle = selectedActivities.length ?? 0 > 0 ? 'Add another activity:' : 'Select your first activity:';
        const nonSelectedContent = unselectedActivities && unselectedActivities.length > 0 ? (_jsxs(NonSelectedWrapper, { children: [_jsx(Title, { children: nonSelectedTitle }), _jsx(List, { children: unselectedActivities.map((activity) => printActivity(activity)) })] })) : _jsx(_Fragment, {});
        const selectedContent = selectedActivities.length > 0 ? (_jsxs(SelectedWrapper, { children: [_jsx(Title, { children: "Selected:" }), _jsx(List, { children: selectedActivities.map((activity) => printActivity(activity, true)) })] })) : _jsx(_Fragment, {});
        const modal = selectedActivity ? (_jsx(AttendeesModal, { onChange: handleModal, onClose: handleModalClose, activity: selectedActivity, activityIdx: getActivityIdx(selectedActivity) })) : _jsx(_Fragment, {});
        return (_jsxs("div", { children: [selectedContent, nonSelectedContent, modal] }));
    };
    return (_jsxs(Wrapper, { children: [!requestingSessions
                ? renderSelectableActivities()
                : _jsx("div", { style: { height: `${Math.min(selectedActivities.length * 144, 250)}px`, width: '100%' } }), _jsx(Actions, { children: _jsx(ContinueButton, { className: "btn btn--secondary", type: "button", disabled: !canProceed, onClick: nextSection, children: buttonText }) })] }));
}
export default ActivityPicker;
